<template>
  <div class="mt-2">
    <label class="form-label">Label</label>
    <vs-select v-model="label" class="w-full">
      <vs-select-item
        :key="index"
        :value="item"
        :text="item"
        v-for="(item, index) in labels"
      />
    </vs-select>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: ["action", "automationId"],
  data() {
    return {
      label: "",
    };
  },
  methods: {
    render() {
      return {
        label: this.label,
      };
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      labels: "guestSegmentation/labels",
    }),
  },
  async mounted() {
    await this.$store.dispatch("guestSegmentation/get", false);
    if (this.action && this.action.label) {
      this.label = this.action.label;
    }
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
.form-label {
  margin-bottom: 0.5rem;
  color: #5e5873;
  font-size: 0.857rem;
}
</style>